import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface ApproverDepartment {
  id: string;
  department_id: string;
  approval_level: number | null;
  max_approval_amount: number | null;
}

export const useIsApprover = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['is-approver', user?.id],
    queryFn: async () => {
      if (!user?.id) {
        return { isApprover: false, departments: [] };
      }

      const { data, error } = await supabase
        .from('department_approvers')
        .select('id, department_id, approval_level, max_approval_amount')
        .eq('user_id', user.id)
        .eq('is_active', true);

      if (error) {
        console.error('Error checking approver status:', error);
        return { isApprover: false, departments: [] };
      }

      return {
        isApprover: data && data.length > 0,
        departments: data as ApproverDepartment[],
      };
    },
    enabled: !!user?.id,
  });
};
